<template>
    <div class="main-section">
        <div class="header-container">
            <a class="logo-block" href="/">
                <img src="../../../assets/svgs/Layer 2.svg" />
            </a>
            <div class="contacts-block">
                <a class="contact-item mail" :href="`mailto:${$globalConfig.contacts.email}`">
                    {{ $globalConfig.contacts.email }}
                </a>
                <div class="middle-line"></div>
                <a class="contact-item" :href="`tel:${$globalConfig.contacts.phone}`">
                    {{ $globalConfig.contacts.phone }}
                </a>
            </div>
        </div>
        <router-view />

        <div class="logos-block">
            <img src="../../../assets/svgs/delta-airlines.svg" class="Delta" />
            <img src="../../../assets/svgs/american-airlines.svg" class="American" />
            <img src="../../../assets/svgs/united-airlines.svg" class="United" />
            <img src="../../../assets/svgs/qatar-airways.svg" class="Qatar Airways" />
        </div>
        <div v-if="showCookiesInfo" class="cookie-block">
            <span class="cookie-title">Cookies</span>
            <div>
                <div>
                    <p class="cookie-body">
                        By using this website, you automatically accept that we use cookies.
                        <a href="/terms.html" target="_blank" class="cookie-link">What for?</a>
                    </p>
                </div>
                <button class="cookie-button" @click="understood">Understood</button>
            </div>
        </div>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import Cookie from 'js-cookie'
import MainForm from './shared/MainForm'

export default {
    name: 'HeaderSection',
    data() {
        return {
            showCookiesInfo: false,
        }
    },
    components: {
        MainForm,
        ModelSelect,
    },
    created() {
        this.showCookiesInfo = Cookie.get('accept-cookies') !== 'true'
    },
    methods: {
        understood() {
            Cookie.set('accept-cookies', true)
            this.showCookiesInfo = Cookie.get('accept-cookies') !== 'true'
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/global-styles';

* {
    box-sizing: border-box;
}

.main-section {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    width: 100%;
    max-width: 1200px;
    margin: 40px auto;

    .header-container {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .logo-block {
            max-width: 260px;
            width: 100%;
            text-decoration: none;
            outline: none;
        }

        .contacts-block {
            display: flex;
            align-items: center;

            .middle-line {
                height: 14px;
                width: 2px;
                margin: 0 5px;
                background-color: $mainTextBlueColor;
            }

            .contact-item {
                font-family: 'Gilroy-Regular', sans-serif;
                text-decoration: none;
                padding: 0 15px;
                color: $mainTextBlueColor;
                font-size: 16px;
                line-height: 20px;
            }
        }
    }

    .header-body-container {
        display: flex;
        justify-content: space-between;
        padding: 0 50px;
        padding-top: 50px;

        .content-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;

            .title-block {
                position: relative;

                .path-arrow {
                    position: absolute;
                    z-index: 20;
                    right: -20px;
                    top: 75px;
                }

                .main-title {
                    font-family: 'Poppins-Bold', sans-serif;
                    font-size: 44px;
                    line-height: 65px;
                    color: $mainTextBlueColor;
                    text-align: center;
                    margin-bottom: 0;
                }

                .main-subtitle {
                    font-family: 'Poppins-Regular', sans-serif;
                    font-weight: lighter;
                    font-size: 18px;
                    line-height: 27px;
                    text-align: left;
                    color: $mainTextBlueColor;
                    max-width: 408px;
                    margin-top: 0;
                }
            }

            .content-form {
                width: 500px;
            }
        }

        .image-container {
            background: url('../../../assets/images/Header/pexels-gustavo-fring-4173229.png');
            width: 478px;
            height: 530px;
            border-radius: 200px 20px 20px 20px;
            background-position: -90px 0px;
            position: relative;

            .bottom-left-image {
                position: absolute;
                left: -30px;
                bottom: -30px;
            }
        }
    }

    .cookie-block {
        display: block;
        position: fixed;
        width: 425px;
        height: 107px;
        padding: 0 10px;
        padding-top: 15px;
        margin-left: auto;
        color: #ffffff;
        letter-spacing: 0px;
        background: #000036 0% 0% no-repeat padding-box;
        border-radius: 6px;
        right: 50px;
        bottom: 50px;
        z-index: 1000;
        opacity: 1;

        .cookie-title {
            font-family: 'Gilroy-SemiBold', sans-serif;
            font-size: 16px;
            line-height: 19px;
            text-transform: capitalize;
        }

        div {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .cookie-body {
                margin: 0;
                margin-top: 10px;
            }

            div {
                width: 50%;
                font-family: 'Gilroy-Light', sans-serif;
                font-size: 14px;
                line-height: 17px;

                .cookie-link {
                    color: #fff;
                    text-align: left;
                    text-decoration: underline;

                    &:hover {
                        text-decoration: none;
                    }
                }
            }

            .cookie-button {
                width: 138px;
                height: 36px;
                border: 0.5px solid #ffffff;
                border-radius: 5px;
                background-color: transparent;
                font-family: 'Gilroy-SemiBold', sans-serif;
                font-size: 16px;
                line-height: 19px;
                color: #ffffff;
                opacity: 1;

                &:hover {
                    transform: scale(1.03);
                    transition-duration: 0.3s;
                    cursor: pointer;
                }
            }
        }
    }

    .logos-block {
        max-width: 734px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        img {
            width: 25%;
        }
    }
}

@media (max-width: 1200px) {
    .main-section {
        max-width: 950px;

        .header-body-container {
            .content-container {
                .title-block {
                    .path-arrow {
                        width: 23px;
                        top: 60px;
                        right: -5px;
                    }

                    .main-title {
                        font-size: 35px;
                        line-height: 50px;
                    }

                    .main-subtitle {
                        font-size: 14px;
                        line-height: 22px;
                        width: 95%;
                        padding-left: 10px;
                    }
                }

                .content-form {
                    width: 395px;
                }
            }

            .image-container {
                width: 378px;
                height: 420px;
                border-radius: 150px 20px 20px 20px;
            }
        }
    }
}

@media (max-width: 992px) {
    .main-section {
        max-width: 720px;

        .header-body-container {
            padding: 0;
            padding-top: 50px;

            .content-container {
                .title-block {
                    .path-arrow {
                        width: 17px;
                        top: 50px;
                        right: 45px;
                    }

                    .main-title {
                        font-size: 26px;
                        line-height: 37px;
                    }

                    .main-subtitle {
                        font-size: 10px;
                        line-height: 16px;
                        width: 80%;
                        padding-left: 60px;
                    }
                }

                .content-form {
                    width: 300px;
                }
            }

            .image-container {
                width: 286px;
                height: 318px;
                border-radius: 100px 20px 20px 20px;
                background-size: 596px 397px;
                background-position: -50px 0px;
            }
        }
    }
}

@media (max-width: 768px) {
    .main-section {
        padding: 0 30px;

        .header-container {
            max-width: 375px;
            margin: 0 auto;

            .logo-block {
                width: 125px;

                img {
                    width: 100%;
                }
            }

            .contacts-block {
                .mail {
                    display: none;
                }

                .middle-line {
                    display: none;
                }

                .contact-item {
                    font-size: 16px;
                    line-height: 25px;
                    padding: 0;
                }
            }
        }

        .header-body-container {
            padding: 0;
            padding-top: 50px;
            display: block;

            .content-container {
                .title-block {
                    .path-arrow {
                        width: 29px;
                        top: 55px;
                        right: 0px;
                    }

                    .main-title {
                        font-size: 32px;
                        line-height: 48px;
                        padding-bottom: 10px;
                    }

                    .main-subtitle {
                        font-size: 14px;
                        line-height: 16px;
                        padding-left: 30px;
                        padding-bottom: 10px;
                    }
                }

                .content-form {
                    width: 353px;
                }
            }

            .image-container {
                display: none;
            }
        }

        .logos-block {
            max-width: unset;
            margin: 20px -30px 0;
            padding: 40px 0;
            display: flex;
            justify-content: space-between;
            width: calc(100% + 60px);
            background: rgb(224, 224, 224, 0.18);
            flex-wrap: wrap;

            img {
                margin: 10px 0;
            }
            .long-img {
                width: 50%;
            }

            .short-img {
                width: 40%;
            }

            @media (max-width: 350px) {
                justify-content: unset;
                align-items: center;

                img {
                    width: unset;
                    margin: 10px auto;
                }
            }
        }

        .cookie-block {
            width: 348px;
            height: 96px;
            position: fixed;
            margin-right: auto;
            right: unset;
            left: 50%;
            bottom: 10px;
            transform: translateX(-50%);

            div {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .cookie-body {
                    margin: 0;
                    margin-top: 10px;
                }

                div {
                    font-size: 12px;
                    line-height: 14px;
                }

                .cookie-button {
                    width: 116px;
                    height: 32px;
                    font-size: 14px;
                    line-height: 16px;
                }
            }
        }
    }
}

@media (max-width: 400px) {
    .main-section {
        max-width: 375px;

        .header-container {
            padding: 0;
        }

        .header-body-container {
            padding: 0;
            padding-top: 50px;
            display: block;

            .content-container {
                .title-block {
                    .path-arrow {
                        width: 27px;
                        top: 55px;
                        right: 10px;
                    }

                    .main-title {
                        font-size: 30px;
                        line-height: 48px;
                        padding-bottom: 10px;
                    }

                    .main-subtitle {
                        font-size: 14px;
                        line-height: 16px;
                        padding-left: 20px;
                        padding-bottom: 10px;
                    }
                }

                .content-form {
                    width: 353px;
                }
            }

            .image-container {
                display: none;
            }
        }
    }
}

@media (max-width: 350px) {
    .main-section {
        max-width: 350px;

        .header-container {
            margin: 0 -10px;

            .contact-item {
                margin-left: 10px;
            }
        }

        .header-body-container {
            padding: 0;
            padding-top: 50px;
            display: block;

            .content-container {
                .title-block {
                    .path-arrow {
                        width: 25px;
                        top: 55px;
                        right: 10px;
                    }

                    .main-title {
                        font-size: 25px;
                        line-height: 40px;
                        padding-bottom: 10px;
                    }

                    .main-subtitle {
                        font-size: 10px;
                        line-height: 12px;
                        padding-left: 20px;
                        padding-bottom: 10px;
                    }
                }

                .content-form {
                    width: 300px;
                }
            }

            .image-container {
                display: none;
            }
        }

        .cookie-block {
            width: 300px;

            div {
                .cookie-body {
                    margin: 0;
                }

                div {
                    font-size: 12px;
                    line-height: 12px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/HeaderSection.vue